'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThreadListHeader = function (_React$PureComponent) {
  _inherits(ThreadListHeader, _React$PureComponent);

  function ThreadListHeader() {
    _classCallCheck(this, ThreadListHeader);

    return _possibleConstructorReturn(this, (ThreadListHeader.__proto__ || Object.getPrototypeOf(ThreadListHeader)).apply(this, arguments));
  }

  _createClass(ThreadListHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'h4',
        {
          style: { textAlign: 'center', color: _colors.OLAF },
          className: 'p-top-11 m-bottom-0'
        },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'visitorWidget.header.threadListTitle' })
      );
    }
  }]);

  return ThreadListHeader;
}(_react2.default.PureComponent);

exports.default = ThreadListHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/components/ThreadListHeader.js
// module id = 1048
// module chunks = 2 3